/**
 * Повреждено ли БАЗОВОЕ строение ячейки (квартал, ферма, казарма и т.п.),
 * а не спецстроение, которое на ней стоит.
 *
 * buildingsDamage — ОДИН счётчик на ячейку, и пока на ней цело спецстроение
 * (крепость, арсенал, лагерь...), весь накопленный урон принадлежит ЕМУ:
 * достигнув порога (FORTRESS_MAX_DAMAGE / SPECIAL_BUILDING_MAX_DAMAGE),
 * спецстроение сносится, а счётчик ячейки обнуляется — см. применение стрельбы
 * и APPLY_MELEE_DAMAGE в sharedStateReducer/index.js (там оба места делают
 * delete nextSpecialBuildings[key] вместе с delete nextBuildingsDamage[key]).
 * Значит базовое строение под целым спецстроением повреждений не имеет вовсе.
 *
 * Отдельная функция нужна потому, что прямая проверка buildingsDamage[key] > 0
 * принимала урон крепости за урон квартала под ней: повреждённая катапультой
 * крепость на центральном квартале запрещала строить смежный базовый квартал.
 *
 * @param {string} hexKey
 * @param {Object} buildingsDamage - накопленный урон по ячейкам
 * @param {Object} specialBuildings - спецстроения по ячейкам
 * @returns {boolean}
 */
export const checkIfBaseBuildingDamaged = (hexKey, buildingsDamage, specialBuildings) => {
  if (!hexKey) {
    return false;
  }
  if (specialBuildings && specialBuildings[hexKey]) {
    return false;
  }
  return ((buildingsDamage && buildingsDamage[hexKey]) || 0) > 0;
};
